import api from "./index";

import cookiesHelper from "../helpers/cookies";

import { EtyUser } from "../interfaces/entities";
import { IUserData } from "../interfaces/forms";

export const getOrganizationUsers = async (organizationId: number): Promise<EtyUser[]> => {
    const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.get(`users/organization/${organizationId}`);
        return res.data?.data?.length ? res.data.data : [];
    } catch (error: any) {
        throw error?.response?.data;
    };
};

export const saveUsers = async (data: IUserData[]) => {
    const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`

    try {
        const res = await api.post(`users/save`, data);
        return res.data;
    } catch (error: any) {
        throw error?.response?.data;
    };
};

export const inviteUsers = async (data: number[]) => {
    const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`

    try {
        const res = await api.post(`users/invite`, data);
        return res.data;
    } catch (error: any) {
        throw error?.response?.data;
    };
};